$(document).ready(function () {
  var refreshCart = function () {
    window.carts.forEach((cart) => {
      cart.onCartUpdated();
    });
  };

  refreshCart();

  var isAddingFreeProduct = false;
  var isAddingFreeProduct2 = false;
  var isAddingBundleFreeProduct = false;

  var autoFreeProduct = function (cart) {
    // if (cart.item_count == 0) {
    //   return false;
    // }
    var hasFreeProduct = false;
    var hasFreeProduct2 = false;
    var hasBundleFreeProduct = false;
    var bundleFreeProductKey = null;
    var freeProductKey = null;
    var elligibleProducts = theme.elligibleProducts.split(",");
    //var is_elligible = false;
    var elligible_count = 0;

    cart.items.forEach(function (item) {
      if (item.id == theme.freeProduct) {
        hasFreeProduct = true;
        freeProductKey = item.key;
        // return;
      } else if (theme.enableFreeProduct2) {
        if (elligibleProducts.includes(item.product_id.toString())) {
          //is_elligible = true;
          elligible_count += item.quantity;
        } else if (item.id == theme.freeProduct2) {
          hasFreeProduct2 = true;
        }
      }
      if (item.id == theme.bundleFreeProduct) {
        hasBundleFreeProduct = true;
        bundleFreeProductKey = item.key;
      }
    });

    var is_elligible =
      elligible_count >= theme.freeElligibleMinQty ? true : false;
    var free_product_threshold = Math.round(
      theme.freeProductThreshold * Shopify.currency.rate
    );
    var freegift_removed = sessionStorage.getItem("freegift_removed");
    var freegift2_removed = sessionStorage.getItem("freegift2_removed");
    var bundlefreegift_removed = sessionStorage.getItem(
      "bundlefreegift_removed"
    );

    if (theme.enableFreeProduct) {
      if (
        cart.total_price >= free_product_threshold &&
        hasFreeProduct == false &&
        !freegift_removed &&
        !isAddingFreeProduct
      ) {
        isAddingFreeProduct = true;
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: theme.freeProduct,
            quantity: 1,
          },
          dataType: "json",
          success: function (res) {
            isAddingFreeProduct = false;
            document.dispatchEvent(new CustomEvent("productAddedToCart"));
            refreshCart();
          },
        });
      } else if (
        cart.total_price < free_product_threshold &&
        hasFreeProduct == true
      ) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: freeProductKey, quantity: 0 },
          dataType: "json",
          success: function (res) {
            refreshCart();
          },
        });
      }
    }

    if (theme.enableFreeProduct2) {
      if (
        is_elligible == true &&
        hasFreeProduct2 == false &&
        !freegift2_removed &&
        !isAddingFreeProduct2
      ) {
        isAddingFreeProduct2 = true;
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: theme.freeProduct2,
            quantity: 1,
          },
          dataType: "json",
          success: function (res) {
            isAddingFreeProduct2 = false;
            document.dispatchEvent(new CustomEvent("productAddedToCart"));
            refreshCart();
          },
        });
      } else if (is_elligible == false && hasFreeProduct2 == true) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: theme.freeProduct2, quantity: 0 },
          dataType: "json",
          success: function (res) {
            refreshCart();
          },
        });
      }

      if (
        is_elligible == true &&
        hasFreeProduct2 == false &&
        freegift2_removed
      ) {
        $("#cart-free-product2-card").removeClass("hide");
      } else if (is_elligible == false || hasFreeProduct2 == true) {
        $("#cart-free-product2-card").addClass("hide");
      }
    }

    if (theme.enableBundleFreeProduct) {
      let totalOneDayQuantity = 0;
      let totalThreeMonthQuantity = 0;

      cart.items.forEach((item) => {
        if (
          item.properties &&
          item.properties._bundle_tag === "Period__1-Day" &&
          item.properties._is_bundle_product
        ) {
          totalOneDayQuantity += item.quantity;
        }
        if (
          item.properties &&
          item.properties._bundle_tag === "Period__3-Month" &&
          item.properties._is_bundle_product
        ) {
          totalThreeMonthQuantity += item.quantity;
        }
      });

      const isEligibleForBundleFreeProduct =
        totalOneDayQuantity >= theme.freeOneDayMinQty ||
        totalThreeMonthQuantity >= theme.freeThreeMonthMinQty;

      if (
        !hasBundleFreeProduct &&
        isEligibleForBundleFreeProduct &&
        !bundlefreegift_removed &&
        !isAddingBundleFreeProduct
      ) {
        isAddingBundleFreeProduct = true;
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: theme.bundleFreeProduct,
            quantity: 1,
          },
          dataType: "json",
          success: function (res) {
            isAddingBundleFreeProduct = false;
            document.dispatchEvent(new CustomEvent("productAddedToCart"));
            refreshCart();
          },
        });
      } else if (hasBundleFreeProduct && !isEligibleForBundleFreeProduct) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: bundleFreeProductKey, quantity: 0 },
          dataType: "json",
          success: function (res) {
            refreshCart();
          },
        });
      }
      if (
        isEligibleForBundleFreeProduct &&
        !hasBundleFreeProduct &&
        bundlefreegift_removed
      ) {
        $("#cart-bundle-free-product").removeClass("hide");
      } else if (hasBundleFreeProduct || !isEligibleForBundleFreeProduct) {
        $("#cart-bundle-free-product").addClass("hide");
      }
    }
  };

  $(document).on("change", ".cart-drawer__input", function () {
    var qty = $(this).val();
    var _itemRow = $(this).closest(".cart-drawer__item");
    var item_key = _itemRow.data("cart-item");
    //var pair_key = _itemRow.data('cart-item-pair');
    var pair_key = null;
    var variant_id = _itemRow.data("cart-item-variant-id");
    var group_id = _itemRow.data("cart-item-group-id");
    var eye = _itemRow.data("cart-item-eye");
    var updated_qty1 = null;
    var updated_qty2 = null;
    var errorMessage =
      "Sorry, only [quantity] items are available in the stock";
    var delay = false;

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        quantity: qty,
        id: item_key,
      },
      success: function (data) {
        data.items.forEach(function (item) {
          //if(item.key == item_key){
          if (group_id == "") {
            if (item.variant_id == variant_id) {
              updated_qty1 = item.quantity;
              return;
            }
          } else {
            if (
              item.properties._group_id == group_id &&
              item.properties.Eye == eye
            ) {
              updated_qty1 = item.quantity;
              //return;
            } else if (
              item.properties._group_id == group_id &&
              item.properties.Eye != eye
            ) {
              pair_key = item.key;
            }
          }
        });

        if (updated_qty1 < qty) {
          errorMessage = errorMessage.replace("[quantity]", updated_qty1);
          _itemRow.find(".cart-drawer__error").text(errorMessage).show();
          delay = true;
        }

        if (pair_key) {
          $(
            '.cart-drawer__item[data-cart-item="' +
              pair_key +
              '"] .cart-drawer__input'
          ).val(updated_qty1);
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
              quantity: updated_qty1,
              id: pair_key,
            },
            success: function (data) {
              data.items.forEach(function (item) {
                //if(item.key == pair_key){
                if (
                  item.properties._group_id == group_id &&
                  item.properties.Eye != eye
                ) {
                  updated_qty2 = item.quantity;
                  return;
                }
              });

              if (updated_qty1 > updated_qty2) {
                errorMessage = errorMessage.replace("[quantity]", updated_qty2);
                //_itemRow.find('.cart-drawer__error').text(errorMessage).show();
                $('.cart-drawer__item[data-cart-item="' + pair_key + '"]')
                  .find(".cart-drawer__error")
                  .text(errorMessage)
                  .show();

                $.ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  dataType: "json",
                  data: {
                    quantity: updated_qty2,
                    id: item_key,
                  },
                  success: function (data) {
                    setTimeout(function () {
                      refreshCart();
                      //autoFreeProduct(data);
                    }, 1000);
                  },
                });
              } else if (delay) {
                setTimeout(function () {
                  refreshCart();
                  //autoFreeProduct(data);
                }, 1000);
              } else {
                refreshCart();
                //autoFreeProduct(data);
              }
            },
          });
        } else if (delay) {
          setTimeout(function () {
            refreshCart();
            //autoFreeProduct(data);
          }, 1000);
        } else {
          refreshCart();
          //autoFreeProduct(data);
        }
      },
    });
  });

  //Add cross-sell product to the cart-drawer
  $(".drawer-addtocart").on("click", function () {
    var _this = $(this);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: _this.data("variant_id"),
        quantity: 1,
      },
      dataType: "json",
      success: function (res) {
        document.dispatchEvent(new CustomEvent("productAddedToCart"));
        refreshCart();
        _this.closest(".item").hide();

        var hide_block = true;
        $(".cart-drawer__cross-sell-products .item").each(function () {
          if ($(this).is(":visible")) {
            hide_block = false;
            return;
          }
        });
        if (hide_block) {
          $(".cart-drawer__cross-sell-products").hide();
        }
      },
    });
  });

  //Add/remove free products automatically whenever there is any change in the cart
  $(document).on("autoFreeProduct", function (event) {
    var cart = event.detail;
    /*if(theme.enableFreeProduct == false || cart.item_count == 0){
      return false;
    } */
    autoFreeProduct(cart);
  });

  $(document).on("click", ".btn-package-content", function () {
    const bundleItems = $(this).next(".bundle-items");
    bundleItems.toggleClass("show");
    if (bundleItems.hasClass("show")) {
      $(this).find("svg").addClass("rotate");
    } else {
      $(this).find("svg").removeClass("rotate");
    }
  });
});
